import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { ModalBody } from "reactstrap";
import { VbzButton, VbzModal } from "@smiles/voebiz-ui-kit";
import { useFlags } from "launchdarkly-react-client-sdk";
import { v4 } from "uuid";

import { FilterRadio } from "..";

import { VoeBizApi } from "../../services/api";

import { FiltersItems } from "./types";

const FilterModal = ({
  isOpen,
  handleClose,
  onExit,
  setPeriod,
  activeTab,
  filter,
  setDataFlights,
}: {
  isOpen: boolean;
  handleClose: () => void;
  onExit: () => void;
  // eslint-disable-next-line no-unused-vars
  setPeriod: (period: string) => void;
  // eslint-disable-next-line no-unused-vars
  setDataFlights: (flights: any) => void;
  filter: {
    LAST_7_DAYS: {
      startDate: string;
      endDate: string;
    };
    LAST_15_DAYS: {
      startDate: string;
      endDate: string;
    };
    LAST_30_DAYS: {
      startDate: string;
      endDate: string;
    };
    NEXT_7_DAYS: {
      startDate: string;
      endDate: string;
    };
    NEXT_15_DAYS: {
      startDate: string;
      endDate: string;
    };
    NEXT_30_DAYS: {
      startDate: string;
      endDate: string;
    };
    NO_INTERVAL: {
      startDate: string;
      endDate: string;
    };
    LOCATOR: {
      startDate: string;
      endDate: string;
    };
  };
  activeTab: string;
}) => {
  const { t } = useTranslation("filter");
  const [isLoading, setIsLoading] = useState(false);

  const [options, setOptions] = useState<string>("NEXT_7_DAYS");
  useEffect(() => {
    setOptions(activeTab === "tab1" ? "NEXT_7_DAYS" : "LAST_7_DAYS");
  }, [activeTab]);

  const filters: FiltersItems = {
    pastPeriod: {
      items: [
        { id: "LAST_7_DAYS", label: t("last7Days") },
        { id: "LAST_15_DAYS", label: t("last15Days") },
        { id: "LAST_30_DAYS", label: t("last30Days") },
        { id: "LOCATOR", label: t("locator") },
      ],
    },
    nextPeriod: {
      items: [
        { id: "NEXT_7_DAYS", label: t("next7Days") },
        { id: "NEXT_15_DAYS", label: t("next15Days") },
        { id: "NEXT_30_DAYS", label: t("next30Days") },
        { id: "LOCATOR", label: t("locator") },
      ],
    },
  };

  const handleCloseModal = () => handleClose();
  const renderFilters = () => {
    const toFilter = activeTab === "tab1" ? filters.nextPeriod : filters.pastPeriod;
    return Object.keys(toFilter).map(() => {
      const element = toFilter;

      return (
        <div className="filter-modal__section" key={v4()}>
          {element.items.map((item) => (
            <FilterRadio
              className="filter-modal__section-radio"
              key={item.id}
              id={item.id}
              label={item.label}
              name={item.id}
              value={item.label}
              checked={item.id === options}
              onChange={() => setOptions(item.id)}
            />
          ))}
        </div>
      );
    });
  };
  const { apiDomain } = useFlags();
  const api = VoeBizApi(apiDomain);
  const submitForm = async (event: any) => {
    event.preventDefault();
    setIsLoading(true);

    try {
      const { startDate, endDate } = filter[options as PeriodFilters];
      setPeriod(options);
      const flightType = options.includes("NEXT") ? "FUTURE" : "PAST";
      const flights = await api.memberFlights("0", "8", flightType, startDate, endDate);
      setDataFlights(flights.response.data.flightList);
      handleClose();
      setIsLoading(false);
    } catch (err) {
      console.error(err);
    }
  };
  return (
    <VbzModal isOpen={isOpen} className="filter-modal" toggle={handleCloseModal} onExit={onExit}>
      <ModalBody>
        <h4 className="filter-modal__title">{t("filterYourSearch")}</h4>
        <form>
          {renderFilters()}
          <VbzButton className="filter-modal__btn" text="Aplicar filtro" onClick={submitForm} isLoading={isLoading} />
        </form>
      </ModalBody>
    </VbzModal>
  );
};

export default FilterModal;
